import { render, staticRenderFns } from "./Buildings.vue?vue&type=template&id=52e21e29&scoped=true&"
import script from "./Buildings.vue?vue&type=script&lang=js&"
export * from "./Buildings.vue?vue&type=script&lang=js&"
import style0 from "./Buildings.vue?vue&type=style&index=0&id=52e21e29&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e21e29",
  null
  
)

export default component.exports